import { type InjectionKey, type Ref } from "vue";

import { ValidationErrors } from "@vm/validation";

export type ErrorCallback = {
  (error: ValidationErrors, isValidationError: true): void;
  (error: unknown, isValidationError: false): void;
};

export const validationErrorsKey = Symbol() as InjectionKey<
  Ref<ValidationErrors | undefined>
>;
export const resetValidationErrorsKey = Symbol() as InjectionKey<() => void>;

export const formDataKey = "formData"; // This injection key uses generics, so it can't be used as a symbol
